<template>
  <div class="home"  v-scroll-reveal="{scale:2}">
    <!-- CARROUSEL DE IMÁGENES (SLIDER) -->
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">

            <div class="carousel-item active" data-interval="4000">
                <a href="https://ventanilla.egob.com/tramitesypagosservicioschiapas/home" target="_blank">
                    <img src="@/assets/imagenes/carousel/VU.png" class="d-block w-100">
                </a>
            </div>

       <!--    <div class="carousel-item" data-interval="4000">
                <img src="@/assets/imagenes/carousel/vehicular-2.jpg" class="d-block w-100">
            </div>-->

            <div class="carousel-item" data-interval="4000">
                <img src="@/assets/imagenes/carousel/horarios.png" class="d-block w-100">
            </div>



            <div class="carousel-item" data-interval="4000">
                <img src="@/assets/imagenes/carousel/kiosco.png" class="d-block w-100">
            </div>
            <div class="carousel-item" data-interval="4000">
                <a href="http://www.haciendachiapas.gob.mx/integridad/ganadores.asp" target="_blank">
                <img src="@/assets/imagenes/carousel/integridad.jpg" class="d-block w-100">
                </a>
            </div>


            <div class="carousel-item" data-interval="4000">
                <a href="http://www.haciendachiapas.gob.mx/planeacion/Informacion/Evaluacion/Evaluacion-PED.pdf" target="_blank">
                    <img src="@/assets/imagenes/carousel/Eval-PED.jpg" class="d-block w-100" >
                </a>
            </div>
            <div class="carousel-item" data-interval="4000">
                <a href="http://www.haciendachiapas.gob.mx/5to-informe/5to-informe.pdf" target="_blank">
                <img src="@/assets/imagenes/carousel/5to-informe.jpg" class="d-block w-100" >
                </a>
            </div>
            <!--  -->
           <!-- <div class="carousel-item" data-interval="4000">
                <img src="@/assets/imagenes/carousel/slider-07.png" class="d-block w-100" >
            </div>-->
           <!-- <div class="carousel-item" data-interval="4000">
                <img src="@/assets/imagenes/carousel/multas-rec.png" class="d-block w-100" >
            </div>-->
            <!--<div class="carousel-item" data-interval="4000">
                <a href="https://docs.google.com/forms/d/1A4q_FIH3PUKMa-kI49yt26Ts6sg9h9_2Xdaox9CPGzY/edit" target="_blank">
                <img src="@/assets/imagenes/carousel/bannerencuestaconducta.jpg" class="d-block w-100" >
                </a>
            </div>-->



            <div class="carousel-item" data-interval="4000">
                <a href="#footer">
                <img src="@/assets/imagenes/carousel/formatosoficiales.jpg" class="d-block w-100" >
                </a>
            </div>
            <div class="carousel-item" data-interval="4000">
                <a href="#">
                <img src="@/assets/imagenes/carousel/hakcer.jpg" class="d-block w-100" >
                </a>
            </div>
            <div class="carousel-item" data-interval="4000">
                <a href="#">
                <img src="@/assets/imagenes/carousel/tramites.jpg" class="d-block w-100" >
                </a>
            </div>
            <div class="carousel-item" data-interval="4000">
                <a href="http://faifap.haciendachiapas.gob.mx/" target="_blank">
                <img src="@/assets/imagenes/carousel/bannerfaifap.jpg" class="d-block w-100" >
                </a>
            </div>
           <!-- <div class="carousel-item" data-interval="4000">
                <a href="http://www.haciendachiapas.gob.mx/codigo-conducta/codigo.pdf" target="_blank">
                <img src="@/assets/imagenes/carousel/codigodeconducta.jpg" class="d-block w-100" >
                </a>
            </div>-->
           <!-- <div class="carousel-item" data-interval="4000">
                <a href="#">
                <img src="@/assets/imagenes/carousel/creditofiscal.jpg" class="d-block w-100" >
                </a>
            </div>-->

        </div>
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
    <!-- MSJ SECRETARIO -->
    <!-- <msj-secretario></msj-secretario> -->
    <!-- CARDS -->
    <cards-component></cards-component>
    <!-- ENTERATE -->
    <enterate-component></enterate-component>
    <!-- BOLETIN OFICIAL (por el momento deshabilitado en el home de ciudadanos) -->
    <prensa-home class=""></prensa-home>
    <!-- OTROS ENLACES -->
    <!-- <otros-enlaces class="mb-5"></otros-enlaces> -->
    <!-- SOCIAL MEDIA -->
    <social-media></social-media>
    <!-- CONTACTANOS -->
    <!-- <contactanos-component class=""></contactanos-component> -->
  </div>
</template>

<script>
// @ is an alias to /src
import msjSecretario from './msjSecretario.vue'
import cardsComponent from './Cards-component.vue'
import enterateComponent from './Enterate-component.vue'
import prensaHome from './prensa.vue'
import otrosEnlaces from './Otros-enlaces.vue'
import socialMedia from './social-media.vue'
import contactanosComponent from './Contactanos'
import SalaPrensa from '../sala-de-prensa/SalaPrensa.vue'

export default {
  name: 'Home',
  computed:{
    dispositivo(){
        if(screen.width>900) return true;
        else return false;
    }
   },
    mounted(){
        window.scrollTo(0, 0);
    },
  components: {
    cardsComponent,
    enterateComponent,
    prensaHome,
    otrosEnlaces,
    socialMedia,
    contactanosComponent,
    SalaPrensa,
    msjSecretario,
  },
  methods:{
    enlace(){
      console.log('log');
      // const height = screen.height;
      // window.scrollTo(height, height);
    }
  }
}
</script>
<style scoped>
    /* .sizeHeight {height: 85vh;}
    @media screen and (min-device-width : 1366px) {
        .w-100 {
            height: 86vh;
        }
    } */
</style>
